/* import __COLOCATED_TEMPLATE__ from './health-check.hbs'; */
/* RESPONSIBLE TEAM: team-app-security */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    app?: {
      id: string;
    };
  };
}

const HealthCheck = templateOnlyComponent<Signature>();

export default HealthCheck;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Workspace::Security::Tabs::HealthCheck': typeof HealthCheck;
    'new-settings/workspace/security/tabs/health-check': typeof HealthCheck;
  }
}
